import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/Rashifal/RashifalShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/image-component.js");
